import React from "react";
import {
	BUCKET_COLORS,
	USERS_EARNING_LABELS,
	formatUsersEarningForTable,
} from "./usersEarningUtils";

/** Summary snapshot cards — summary.usersEarning (all-source wallet, not day-wise partner) */
const UserEaringChart = ({ summary }) => {
	const buckets = formatUsersEarningForTable(summary ?? []);

	return (
		<div>
			<p style={{ fontSize: 13, color: "var(--text-muted)", margin: "0 0 14px 0" }}>
				Summary wallet earnings (all sources). Day-wise partner postback buckets are shown separately below.
			</p>
			<div
				style={{
					display: "grid",
					gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
					gap: "var(--spacing-lg)",
				}}
			>
				{buckets.map((b) => (
					<div
						key={String(b.id)}
						style={{
							padding: "20px",
							borderLeft: `4px solid ${BUCKET_COLORS[b.id]}`,
							backgroundColor: "white",
							borderRadius: "8px",
							boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
						}}
					>
						<p style={{ margin: "0 0 8px 0", fontSize: "13px", fontWeight: "600", color: "var(--text-muted)", textTransform: "uppercase" }}>
							{USERS_EARNING_LABELS[b.id]} Coins
						</p>
						<p style={{ margin: 0, fontSize: "28px", fontWeight: "700", color: BUCKET_COLORS[b.id] }}>
							{(b.total_users ?? 0).toLocaleString()}
						</p>
					</div>
				))}
			</div>
		</div>
	);
};

export default UserEaringChart;
